module.exports = __webpack_public_path__ + "img/banner-mobile.6b16e951.png";